module.exports = __webpack_public_path__ + "static/media/32.faf79658.mp3";